import { defineComponent, createElementBlock, createBlock, unref, openBlock, renderSlot, normalizeProps, mergeProps, withCtx } from "vue";
import { isExternalLink } from "../link.js";
import { sanitizeUrl } from "../sanitization.js";
import { RouterLink } from "vue-router";
const _hoisted_1 = ["href"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PLink"
  },
  __name: "p-link",
  props: {
    custom: { type: Boolean },
    activeClass: {},
    exactActiveClass: {},
    ariaCurrentValue: {},
    viewTransition: { type: Boolean },
    to: {},
    replace: { type: Boolean }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return typeof _ctx.to === "string" && unref(isExternalLink)(_ctx.to) ? (openBlock(), createElementBlock("a", {
        key: 0,
        href: unref(sanitizeUrl)(_ctx.to),
        target: "_blank"
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_1)) : (openBlock(), createBlock(unref(RouterLink), normalizeProps(mergeProps({ key: 1 }, _ctx.$props)), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16));
    };
  }
});
export {
  _sfc_main as _
};
